export const PAWS_BRAINTREE_CC_EXPERIMENT_KEY = "tc-1046-use-pawsbraintreecc";
